module.exports = __webpack_public_path__ + "img/drucken-weiss.216c29c5.svg";